// Library Imports
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Local Imports
import usersListingSlice from "./reducers/adminReducers/usersReducer";
import userVerificationSlice from "./reducers/adminReducers/userVerificationReducer";
import registerUserSlice from "./reducers/authReducers/authReducers";
import rolesInterestsSlice from "./reducers/authReducers/rolesInterestsReducer";
import statesSlice from "./reducers/authReducers/statesReducer";
import certificationsSlice from "./reducers/userReducers/certificationReducer/certificationReducer";
import profileDetailsSlice from "./reducers/userReducers/editProfileReducers/editProfileReducer";
import educationsSlice from "./reducers/userReducers/educationReducer/educationReducer";
import experienceSlice from "./reducers/userReducers/experienceReducer/experienceReducer";
import licensesSlice from "./reducers/userReducers/licensesReducer/licensesReducer";
import notificationSlice from "./reducers/userReducers/notificationReducer/notificationReducer";
import profileCompletionSlice from "./reducers/userReducers/profileCompletionReducer/profileCompletionReducer";
import projectsSlice from "./reducers/userReducers/projectReducers/projectRecuer";
import recommendationsSlice from "./reducers/userReducers/recommendationsReducer/recommendationsReducer";
import signupSuggestionsSlice from "./reducers/userReducers/signupSuggestedPartnersReducer/signupSuggestedPartnersReducer";
import skillsSlice from "./reducers/userReducers/skillsReducer/skillsReducer";
import portfolioImagesSlice from "./reducers/userReducers/PortfolioImagesReducer/PortfolioImagesReducer";
import contractHistorySlice from "./reducers/contractReducers/contractHistoryReducer";
import verificationSlice from "./reducers/userReducers/verificationReducer/verificationReducer";

// Define configuration & reducers you want to persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user", "cities", "states", "profileDetails"],
};

// Combine your reducers
const rootReducer = combineReducers({
  user: registerUserSlice,
  rolesInterests: rolesInterestsSlice,
  states: statesSlice,
  usersListing: usersListingSlice,
  profileDetails: profileDetailsSlice,
  skills: skillsSlice,
  experience: experienceSlice,
  projects: projectsSlice,
  certifications: certificationsSlice,
  licenses: licensesSlice,
  recommendations: recommendationsSlice,
  educations: educationsSlice,
  signupSuggestions: signupSuggestionsSlice,
  verification: userVerificationSlice,
  ProfileCompletion: profileCompletionSlice,
  portfolioImages: portfolioImagesSlice,
  notifications: notificationSlice,
  contractHistory: contractHistorySlice,
  userVerification: verificationSlice,
});

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

// Create a persistor
export const persistor = persistStore(store);
